import axios from "axios";
export const BoxApiUrl = process.env.REACT_APP_OCPW_BOX_URL;
const vestingDocsUrl = `https://webapps.ocgis.com/vestingdocs/`;
const floodHtmlPage = `flood.html`;
const encumbrancesHtmlPage = `encumbrances.html`;
const miscFacilityHtmlPage = `miscfacility.html`;
const parkParcelsHtmlPage = `ocparks.html`;
const roadHtmlPage = `road.html`;
export const OcpwGetBoxSurveyDoc = async (
  view,
  layerIds,
  layerId,
  attributes
) => {
  var fieldDict = {};
  let LegalLotsId = layerIds["parcels"];
  let AlignmentNotesId = layerIds["alignmentNotes"];
  let CertificateOfComplianceId = layerIds["certificateOfCompliance"];
  let CityAnnexationId = layerIds["cityAnnexations"];
  let CityTiesId = layerIds["cityTies"];
  let cornerRecordId = layerIds["cornerRecords"];
  let CountySurveyorTieBooksId = layerIds["countySurveyorTieBooks"];
  let FloodChannelsAndAsBuiltsId = layerIds["floodChannelsAndAsBuilts"];
  let HorizontalControlId = layerIds["horizontalControlPoints"];
  let JackRaubNotesId = layerIds["jackRaubNotes"];
  let LotLineAdjustmentId = layerIds["lotLineAdjustments"];
  let OcfcdFieldNotesId = layerIds["ocfcdFieldNotes"];
  let OcrtnId = layerIds["ocrtn"];
  let MiscellaneousDocumentsId = layerIds["miscellaneousDocuments"];
  let MiscellaneousRecordsLAId = layerIds["miscellaneousRecordsLA"];
  let MonumentRecordsId = layerIds["monumentRecords"];
  let ParcelMapId = layerIds["parcelMaps"];
  let RoadDeedId = layerIds["roadDeeds"];
  let RecordsOfSurveyId = layerIds["recordsOfSurvey"];
  let SurveyFieldNotesId = layerIds["surveyFieldNotes"];
  let SurveyorMapsId = layerIds["surveyorMaps"];
  let TractMapId = layerIds["tractMaps"];
  let TopographicSurveysId = layerIds["topographicSurveys"];
  let VerticalControlPointsId = layerIds["verticalControlPoints"];
  let EncumbrancesId = layerIds["encumbrances"];
  let FloodParcelsId = layerIds["floodParcels"];
  let MiscFacilitiesId = layerIds["miscFacilities"];
  let ParkParcelsId = layerIds["parkParcels"];
  let RoadParcelsId = layerIds["roadParcels"];
  let VacationAndAbandonmnetsId = layerIds["vacationsAndAbandonments"];
  let TrafficCollisionId = layerIds["trafficCollisions"];

  fieldDict[LegalLotsId] = "AssessmentNo";
  fieldDict[AlignmentNotesId] = "BPNUM"; //replace("&", "_")
  fieldDict[CertificateOfComplianceId] = "Name";
  fieldDict[CityAnnexationId] = "Name"; //replace("#","")
  fieldDict[CityTiesId] = "FILENAME";
  fieldDict[cornerRecordId] = "crnum";
  fieldDict[CountySurveyorTieBooksId] = "BPNUM";
  fieldDict[FloodChannelsAndAsBuiltsId] = "DrawingNum";
  fieldDict[HorizontalControlId] = "GPS";
  fieldDict[JackRaubNotesId] = "FILENAME";
  fieldDict[LotLineAdjustmentId] = "Name";
  fieldDict[OcfcdFieldNotesId] = "File_Name";
  fieldDict[OcrtnId] = "GPS";
  fieldDict[MiscellaneousDocumentsId] = "Name";
  fieldDict[MiscellaneousRecordsLAId] = "BPNUM";
  fieldDict[MonumentRecordsId] = "GPSNUM";
  fieldDict[ParcelMapId] = "Name";
  fieldDict[RoadDeedId] = "Name";
  fieldDict[RecordsOfSurveyId] = "BPNum";
  fieldDict[SurveyFieldNotesId] = "FileName";
  fieldDict[SurveyorMapsId] = "SMNum";
  fieldDict[TractMapId] = "Name";
  fieldDict[TopographicSurveysId] = "FileName";
  fieldDict[VerticalControlPointsId] = "Designation";
  fieldDict[EncumbrancesId] = "OBJECTID";
  fieldDict[FloodParcelsId] = "OBJECTID";
  fieldDict[MiscFacilitiesId] = "OBJECTID";
  fieldDict[ParkParcelsId] = "OBJECTID";
  fieldDict[RoadParcelsId] = "OBJECTID";
  fieldDict[VacationAndAbandonmnetsId] = "Name";
  fieldDict[TrafficCollisionId] = "Report_Number";

  var docFieldName = fieldDict[layerId];
  const attachmentList = [];
  const getBoxDoc = async (docname, organization) => {
    const getFileID = async (): Promise<any> => {
      let parameters = {
        params: {
          exactmatch: true,
          organization: organization,
          search: docname,
        },
      };
      //console.log("parameters: ", parameters);
      return new Promise(function (resolve, reject) {
        axios.get(BoxApiUrl, parameters).then(
          (response) => {
            resolve(response);
          },
          (error) => {
            console.error("startWorkItem error:", error);
            reject(error);
          }
        );
      });
    };

    const getFileIdResponse = await getFileID();
    //console.log("Box response", getFileIdResponse);

    if (getFileIdResponse.data.Items.length === 0) {
      return [];
    }

    const shareLink = await getBoxShareLink(getFileIdResponse.data.Items[0].id);
    const attachmentObj = {};
    attachmentObj["name"] = docname;
    attachmentObj["displayType"] = "iframe";
    attachmentObj["source"] = "box";
    attachmentObj["url"] = shareLink.data; //this will be for the permanent shared link
    attachmentObj["fileId"] = getFileIdResponse.data.Items[0].id;
    attachmentObj["organization"] = organization;
    attachmentList.push(attachmentObj);
  };

  let docname = "";
  let organization = "OCPW_Survey"; //default organization
  if (docFieldName) {
    docname = view.popup._feature.graphic.attributes[docFieldName];
    if (docFieldName === "AssessmentNo") {
      let tempdocname = docname.replaceAll("-", "").substring(0, 5);
      docname = tempdocname;
      await getBoxDoc(`${docname.substring(0, 3)}00`, organization);
    }

    // Condition TrafficCollisionId
    if (layerId === TrafficCollisionId) {
      organization = "OCPW_INFRASTRUCTURE";
    }

    // Condition CityAnnexationId
    if (docFieldName === "Name" && layerId === 999017) {
      let tempdocname = docname.replaceAll("#", "");
      docname = tempdocname;
    }

    //Right of Way Vesting Documents Conditions
    if (layerId === FloodParcelsId) {
      attachmentList.push({
        displayType: "iframe",
        name: "Link",
        url: `${vestingDocsUrl}${floodHtmlPage}?oid=${docname}`,
      });
      return attachmentList;
    }
    if (layerId === EncumbrancesId) {
      attachmentList.push({
        displayType: "iframe",
        name: "Link",
        url: `${vestingDocsUrl}${encumbrancesHtmlPage}?oid=${docname}`,
      });
      return attachmentList;
    }
    if (layerId === MiscFacilitiesId) {
      attachmentList.push({
        displayType: "iframe",
        name: "Link",
        url: `${vestingDocsUrl}${miscFacilityHtmlPage}?oid=${docname}`,
      });
      return attachmentList;
    }
    if (layerId === ParkParcelsId) {
      attachmentList.push({
        displayType: "iframe",
        name: "Link",
        url: `${vestingDocsUrl}${parkParcelsHtmlPage}?oid=${docname}`,
      });
      return attachmentList;
    }
    if (layerId === RoadParcelsId) {
      attachmentList.push({
        displayType: "iframe",
        name: "Link",
        url: `${vestingDocsUrl}${roadHtmlPage}?oid=${docname}`,
      });
      return attachmentList;
    }

    await getBoxDoc(docname, organization);
    console.log(attachmentList);
    return attachmentList;
  } else {
    return [];
  }
};

export const getBoxShareLink = async (boxfileid): Promise<any> => {
  return new Promise(function (resolve, reject) {
    axios.get<any>(`${BoxApiUrl}/file/${boxfileid}/shared-link`).then(
      (response) => {
        resolve(response);
      },
      (error) => {
        console.error("startWorkItem error:", error);
        reject(error);
      }
    );
  });
};

export const getEmbedUrl = async (boxfileid): Promise<any> => {
  return new Promise(function (resolve, reject) {
    axios.get<any>(`${BoxApiUrl}/file/${boxfileid}/embed-link`).then(
      (response) => {
        resolve(response);
      },
      (error) => {
        console.error("startWorkItem error:", error);
        reject(error);
      }
    );
  });
};
